import type {
    AvailablePayoutOption,
    TinkBankAccountDto
} from 'tradera/state/services/types/webapi-member-generated';

export type PayoutState = {
    hyperwallet?: PayoutSettingsHyperwallet;
    updateStatus: PayoutUpdateStatus;
    modalState: PayoutDestinationModalState;
    payoutFrequencyOption?: string;
    availablePayoutOptions: AvailablePayoutOption[];
    displayedPayoutOptions: AvailablePayoutOption[];
    requireBankIdVerification: boolean;
    isFetching: boolean;
    showSettingsModal: boolean;

    tink: PayoutTinkState;
    bankAccount: PayoutBankState;
    paypal: PayoutPayPalState;
    swish: PayoutSwishState;
};

export type PayoutUpdateStatus = {
    isUpdating: boolean;
    processCorrelationId?: string;
    errorMessage?: string;
};

export type PayoutTinkState = {
    tinkLinkUrl: string;
    accounts?: TinkBankAccountDto[] | null;
    account?: string;
    errorMessage?: string;
    isFetching: boolean;
};

export type PayoutDestinationModalState = {
    selectedOption?: AvailablePayoutOption;
    isAccountValid?: boolean;
    currentView?: PayoutDestinationModalView;
};

export enum PayoutDestinationModalView {
    SelectOption = 'SelectOption',
    UnknownBank = 'UnknownBank',
    VerifySwish = 'VerifySwish'
}

export type PayoutBankState = {
    clearingNumber: string;
    accountNumber: string;
};

export type PayoutPayPalState = {
    emailAddress: string;
};

export type PayoutSwishState = {
    swishNumber?: string;
    verificationCode?: string;
};

export type PayoutSettingsHyperwallet = {
    userToken?: string | null;
    widgetBaseUrl?: string | null;
};
